module.exports = __webpack_public_path__ + "images/cebsb_logo.1788839706626.png";